<div class="login-container">
      <div class="background-section" [style.backgroundImage]="themeLoaded() ? 'url(' + theme().backgroundUrl + ')' : 'none'">
      </div>
      <main class="login-form-section">
          <div class="login-box">
              @if (themeLoaded()) {
              <img [src]="theme().logoUrl" alt="Company Logo" class="form-logo" (error)="onImageError('form-logo')">
              }

              @if (isAccountSetup()) {
              <!-- Account Setup Message -->
              <div class="setup-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
              </div>
              <h1>Account Setup in Progress</h1>
              <p class="setup-message">Your account is being configured.<br>Please try again shortly or contact your administrator.</p>
              <a [href]="accountSetupEmail() ? '/login?email=' + accountSetupEmail() : '/login'" class="btn-sign-in btn-back-to-login">Go to Login Page</a>
              } @else {
              <!-- Normal Login Form -->
              <h1>Welcome Back</h1>
              <p>Sign in to access your portal</p>

              @if (errorMessage()) {
              <div class="error-banner">
                  {{ errorMessage() }}
              </div>
              }

              @if (invitationError()) {
              <div class="error-banner">
                  {{ invitationError() }}
              </div>
              }

              @if (!isLoggedIn()) {
              <form (submit)="login()">
                  <div class="input-group">
                      <label for="email">Email Address</label>
                      <input type="email" id="email" name="email" [ngModel]="loginEmail()" (ngModelChange)="loginEmail.set($event)" placeholder="Enter your email address" required>
                      <small class="helper-text">We'll use the email above to sign you in.</small>
                  </div>

                  <div class="button-row">
                      <button type="submit" class="btn-sign-in" [disabled]="!loginEmail() || !loginEmail().trim() || loginInProgress()">
                          Continue
                      </button>
                  </div>
              </form>
              }
              }

          </div>
      </main>
  </div>
